<div id="ryft-google-pay"></div>
<div id="ryft-apple-pay"></div>
<form id="ryft-pay-form" (submit)="submit($event)">
  <div id="ryft-card-form"></div>
  <div id="ryft-field-collection"></div>
  <button id="pay-btn" class="primary-button w-full" [disabled]="!cardValid() || !addressValid() || loading()">Pay</button>
  @if(error(); as error){
  <div id="ryft-pay-error" class="text-error">{{ error }}</div>
  }
</form>
